/**
 * LandingHero - Hero section for the landing page
 */
import { Link } from 'react-router-dom'
import {
  CheckCircle2,
  ArrowRight,
  Sparkles,
  Lock,
  HeadphonesIcon,
} from 'lucide-react'
import { Button } from '../components/ui/button'
import { Badge } from '../components/ui/badge'

const stats = [
  { value: '54', label: 'African Countries' },
  { value: '500+', label: 'Products Available' },
  { value: '10K+', label: 'Businesses Served' },
  { value: '24/7', label: 'Local Support' },
]

const trustIndicators = [
  { icon: CheckCircle2, text: 'Official Microsoft Partner', iconClass: 'text-green-500' },
  { icon: Lock, text: 'Secure Payments', iconClass: '' },
  { icon: HeadphonesIcon, text: '24/7 African Support', iconClass: '' },
]

export function HeroSection() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-blue-600/5" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-transparent to-transparent" />

      <div className="container relative px-4 md:px-6 py-16 md:py-24 lg:py-32">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
          <Badge variant="secondary" className="mb-4 px-4 py-1.5">
            <Sparkles className="h-3.5 w-3.5 mr-1.5" />
            Trusted by 10,000+ African Businesses
          </Badge>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6">
            Software Licenses for{' '}
            <span className="bg-gradient-to-r from-primary via-blue-500 to-blue-600 bg-clip-text text-transparent">
              African Businesses
            </span>
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl">
            Microsoft 365, security software, backup, and more—all with local support,
            local payments, and pricing that makes sense for African businesses.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button size="lg" className="gap-2 text-base px-8" asChild>
              <Link to="/login">
                Get Started
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="text-base px-8" asChild>
              <Link to="/catalog">Browse Products</Link>
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm text-muted-foreground">
            {trustIndicators.map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <item.icon className={`h-4 w-4 ${item.iconClass}`} />
                {item.text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export function StatsSection() {
  return (
    <section className="border-y bg-muted/30">
      <div className="container px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary mb-1">{stat.value}</div>
              <div className="text-sm text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
